import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  FallOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import { Drawer, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { summaryService } from "../api";
import { useSelector } from "react-redux";
import {
  getMainProduct,
  getProduct,
  getProducts,
  getThread,
} from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { calcChange, findSource } from "../scripts/utils";
import Coverage from "./Coverage";
import NetworkIcon from "../scripts/network-icon";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/store/hooks";
import {
  setProduct,
  setReferences,
  setReferencesFilter,
} from "../redux/actions";

const MediaIndex: React.FC = () => {
  const thread = useSelector(getThread);
  const product = useSelector(getProduct);
  const mainProduct = useSelector(getMainProduct);
  const products = useSelector(getProducts);
  const feedFilter = useSelector(getFeedFilter);
  const [loading, setLoading] = useState(true);
  const [totalMediaindex, setTotalMediaindex] = useState(0);
  const [client, setClient] = useState("");
  const [previousMediaindex, setPreviousMediaindex] = useState(0);
  const [competitors, setCompetitors] = useState([]);
  const [top, setTop] = useState({ social_networks: [], smi: [] });
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    if (thread && product && mainProduct) {
      let params = {
        thread_id: +thread.id,
        product_id: window.location.pathname.includes("main")
          ? mainProduct?.id
          : product,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
      };
      setTimeout(
        () =>
          summaryService
            .loadMediaIndexInfo(params)
            .then((resp) => {
              setCompetitors(resp.competitors.items);
              setTop(resp.client.top);
              setTotalMediaindex(resp.client.media_index);
              setClient(resp.client.title);
              let calc = calcChange(
                resp.client.media_index,
                resp.client.previous.media_index
              );

              setPreviousMediaindex(+calc);
              setLoading(false);
            })
            .catch((error) => {
              console.log(error);
            }),
        1000
      );
    }
  }, [thread, feedFilter, product, mainProduct]);

  const changeDist = (competitor: any) => {
    let prod = products.find(
      (it: any) => it?.client?.id == competitor.reference_item_id
    )?.id;
    dispatch(setProduct(prod));
    dispatch(setReferencesFilter([competitor.reference_item_id]));
    dispatch(setReferences([competitor.reference_item_id]));
    if (window.location.pathname.includes("main")) navigate("/districts");
  };

  const changeDistThread = (competitor: any) => {
    let prod = products.find(
      (it: any) => it?.client?.id == competitor.reference_item_id
    )?.id;
    dispatch(setProduct(prod));
    dispatch(setReferencesFilter([competitor.reference_item_id]));
    dispatch(setReferences([competitor.reference_item_id]));
    navigate("/thread");
  };

  return (
    <div className="grid2_1">
      <div className="white-block-small">
        <div className="flex-space">
          <p className="block-title">
            ERR {!loading && client}
            <InfoCircleOutlined className="info" onClick={showDrawer} />
          </p>
        </div>
        {loading ? (
          <div className="feed-posts-loader" style={{ height: "300px" }}>
            <LoadingOutlined />
          </div>
        ) : (
          <div>
            <div className="flex margin-bottom mobile-flex">
              <div className="title-big">{totalMediaindex}</div>
              <Tooltip
                color={"#7856FE"}
                title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
              >
                {previousMediaindex > 0 ? (
                  <div className="green green-bg">
                    <RiseOutlined /> +{previousMediaindex?.toFixed(2)}%
                  </div>
                ) : (
                  <div className="red red-bg">
                    <FallOutlined /> {previousMediaindex?.toFixed(2)}%
                  </div>
                )}
              </Tooltip>
            </div>
            {/*<p className="block-title">Конкуренты</p>*/}
            <div className="grid4 margin-bottom">
              {competitors
                ?.sort((a: any, b: any) => a.title.localeCompare(b.title))
                ?.map((competitor: any, id) => (
                  <div className="flex" key={id}>
                    <div className="small-img-frame">
                      <img
                        src={
                          mainProduct?.client?.title == "Ярославская область"
                            ? "/yar.svg"
                            : "/gov.svg"
                        }
                        alt=""
                      />
                    </div>
                    <div>
                      <p
                        className="grey btn-cursor"
                        onClick={() => changeDist(competitor)}
                      >
                        {competitor?.title}
                      </p>
                      <div
                        className="flex-baseline btn-cursor"
                        onClick={() => changeDistThread(competitor)}
                      >
                        <div className="title-small">
                          {competitor?.media_index}
                        </div>
                        <Tooltip
                          color={"#7856FE"}
                          title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                        >
                          <div
                            className={
                              competitor?.previous.media_index >=
                              competitor?.media_index
                                ? "red"
                                : "green"
                            }
                          >
                            {calcChange(
                              competitor?.media_index,
                              competitor?.previous.media_index
                            )}
                            %
                            {competitor?.previous.media_index >=
                            competitor?.media_index ? (
                              <ArrowDownOutlined />
                            ) : (
                              <ArrowUpOutlined />
                            )}
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="grid2">
              {top.social_networks.length > 0 && (
                <div className="grid-block gray-block">
                  <p className="block-title">В соцсетях</p>
                  {top.social_networks.map((it: any, id) => (
                    <div className="white-block-small grid3-1-1" key={id}>
                      <div className="flex">
                        <NetworkIcon networkName={it.code} />
                        <div className="grey">{findSource(it.code)}</div>
                      </div>
                      <Tooltip
                        color={"#7856FE"}
                        title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                      >
                        <div
                          className={
                            it.mentions.current <= it.mentions.previous
                              ? `red flex-simple`
                              : `green flex-simple`
                          }
                        >
                          {calcChange(
                            it.mentions.current,
                            it.mentions.previous
                          )}
                          {it.mentions.current <= it.mentions.previous ? (
                            <ArrowDownOutlined />
                          ) : (
                            <ArrowUpOutlined />
                          )}
                        </div>
                      </Tooltip>
                      <div className="block-title">{it.mentions.current}</div>
                    </div>
                  ))}
                </div>
              )}
              {top.smi.length > 0 && (
                <div className="grid-block gray-block">
                  <p className="block-title">В СМИ</p>
                  {top.smi.map((it: any, id) => (
                    <div className="white-block-small grid3-1-1" key={id}>
                      <div className="flex">
                        <img src={it.image} className="source-icon"></img>
                        <div className="grey">{it?.username}</div>
                      </div>
                      <Tooltip
                        color={"#7856FE"}
                        title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                      >
                        <div
                          className={
                            it.mentions.current <= it.mentions.previous
                              ? `red flex-simple`
                              : `green flex-simple`
                          }
                        >
                          {calcChange(
                            it.mentions.current,
                            it.mentions.previous
                          )}{" "}
                          {it.mentions.current <= it.mentions.previous ? (
                            <ArrowDownOutlined />
                          ) : (
                            <ArrowUpOutlined />
                          )}
                        </div>
                      </Tooltip>
                      <div className="block-title">{it.mentions.current}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Coverage title={"viewed"} />
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <div className="overflow-block">
          <p className="purple-border">
            ERR - «Уровень вовлеченности по охвату». Данный показатель дает
            понимание о том, какой процент подписчиков просматривает публикации
            в рассматриваемых источниках. Именно «просматривает», текст
            публикации на самом деле может быть и не прочитан подписчиком.
            Рассчитывается как отношение среднего охвата публикации к количеству
            подписчиков канала.
          </p>
          <p className="title-small">Как интерпретировать данные</p>
          <ol>
            <li>
              Необходимо выбрать интересующий временной интервал, после чего
              будет сформирован числовой показатель ERR. Рядом с индексом
              отобразится процент роста/спада показателей по сравнению с
              предыдущим периодом.
            </li>
            <li>
              Формула: делим среднее количество просмотров на количество
              подписчиков в канале и умножаем на 100
            </li>
          </ol>
          <p className="title-small">Источники данных</p>
          <ul>
            <li>Telegram</li>
            <li>Вконтакте</li>
            <li>Одноклассники</li>
            <li>Youtube</li>
            <li>Дзен</li>
          </ul>
        </div>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default MediaIndex;
